'use client'

import { Checkbox } from '@/components/ui/checkbox'
import { FieldShell } from './field-shell'
import type { AnswerableFieldProps } from './types'

export function MultiSelectField({
  props,
  mode,
  value,
  onChange,
  error
}: AnswerableFieldProps<'MultiSelect', string[]>) {
  const isPreview = mode === 'preview'
  const options = props.options ?? []
  const selected = Array.isArray(value) ? value : []

  return (
    <FieldShell
      mode={mode}
      label={props.label}
      required={props.required}
      helpText={props.helpText}
      error={error}
      conditional={Boolean(props.showIf)}
    >
      <div className="space-y-1">
        {options.map(opt => (
          <label key={opt} className="flex items-center gap-2 text-sm">
            <Checkbox
              checked={isPreview ? false : selected.includes(opt)}
              onCheckedChange={
                isPreview
                  ? undefined
                  : checked => {
                      const next = checked === true ? [...selected, opt] : selected.filter(x => x !== opt)
                      onChange?.(next)
                    }
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
    </FieldShell>
  )
}
